<template>
    <div>
        <i :class="{'icon-bookmark21': wishlistCount, 'icon-bookmark-empty': !wishlistCount}"></i>
        <span v-if="wishlistCount" class="badge">{{wishlistCount}}</span>
    </div>
</template>

<script>
    export default {
        props: ['dataWishlistCount'],
        data() {
            return {
                wishlistCount: parseInt(this.dataWishlistCount),
            }
        },
        mounted() {
            this.$root.$on('updateWishlist', wishlistCount => {
                this.wishlistCount = wishlistCount
            });
        }
    }
</script>
